import { render, staticRenderFns } from "./SchoolGroupSettings.vue?vue&type=template&id=62e97320&"
import script from "./SchoolGroupSettings.ts?vue&type=script&lang=ts&"
export * from "./SchoolGroupSettings.ts?vue&type=script&lang=ts&"
import style0 from "./SchoolGroupSettings.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports